import axios from 'axios'
import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { setHttpToken } from '../../helpers/httpToken'
import qs from 'qs'
import router from '../../router'

const state = {
  user: {
    authenticated: false,
    data: null
  }
}

const getters = {
  user: (state) => {
    return state.user
  }
}

const actions = {
  async login ({ dispatch }, { payload, context }) {
    let response = await dispatch('fetchToken', { context, payload })

    await dispatch('setToken', response.data.token)
    return await dispatch('fetchUser')
  },

  async fbLogin ({ dispatch }, { payload, context }) {
    let response = await dispatch('fetchfbToken', { context, payload })

    await dispatch('setToken', response.data.token)
    return await dispatch('fetchUser')
  },

  // eslint-disable-next-line
  async fetchToken ({ commit }, { payload, context }) {
    let data = qs.stringify({
      email: payload.username,
      pwd: payload.password
    })

    return await axios.post('loginForTeacher.php', data)
  },
  async fetchfbToken ({ commit }, { payload, context }) {
    let data = qs.stringify({
      id: payload.id,
    })

    return await axios.post('facebookLogin.php', data)
  },

  async fetchUser ({ commit, dispatch }) {
    try {
      let response = await axios.get('me.php')

      commit('setAuthenticated', true)
      commit('setUserData', response.data.data)
      return response

    } catch (error) {
      dispatch('clearAuth')
      router.replace({ name: 'login' })
    }
  },

  setToken ({ commit, dispatch }, token) {
    // refresh
    if (isEmpty(token)) {
      return dispatch('checkTokenExists').then((token) => {
        // token not empty
        setHttpToken(token)
      })
    }

    commit('setToken', token)
    setHttpToken(token)
  },

  checkTokenExists () {
    return localforage.getItem('authtoken').then((token) => {
      if (isEmpty(token)) {
        return Promise.reject('NO_STORAGE_TOKEN') // token not exists
      }
      return Promise.resolve(token) // token exists
    })
  },

  clearAuth ({ commit }) {
    commit('setAuthenticated', false)
    commit('setUserData', null)
    commit('setToken', null)
    setHttpToken(null)
  },

  logout ({ dispatch }) {
    dispatch('clearAuth')
  }
}

const mutations = {
  setToken (state, token) {
    if (isEmpty(token)) {
      localforage.removeItem('authtoken', token)
      return
    }
    localforage.setItem('authtoken', token)
  },

  setAuthenticated (state, trueOrFalse) {
    state.user.authenticated = trueOrFalse
  },

  setUserData (state, data) {
    state.user.data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
